import e from "../managers/braze-instance.js";
export function subscribeToSdkAuthenticationFailures(r) {
  if (!e.rr()) return;
  const n = e.Sr();
  return n ? n.subscribeToSdkAuthenticationFailures(r) : void 0;
}
